import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import NumberOfLogsFormStyle from './css/NumberOfLogsFormStyle'
import LogsController from '../reports/logs/LogsController'

function NumberOfLogsForm(props) {
    const setContent = props.app.content[1]
    const [numberOfLogs, setNumberOfLogs] = useState(1000)

    const onClick = (button) => {
        if (button === 'Apply') { setContent(<LogsController nol={numberOfLogs} />) }
        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
    }
    
    const onKeyUp = (e) => {
        if (e.key === 'Enter')
            if (e.target.id === 'cancel-button') onClick('Cancel')
            else onClick('Apply')
        if (e.key === 'Escape') onClick('Cancel')
    }

    return (
        <React.Fragment>
            <div onKeyUp={onKeyUp} className='nol-container'>
                <div className='form-container'>
                    <div className='input-wrapper'>
                        <label htmlFor='number-of-logs'>Number of Logs</label>
                        <input
                            id='number-of-logs'
                            className='number-of-logs top-anchor'
                            type='number'
                            min='0'
                            placeholder='Number of Logs'
                            value={numberOfLogs}
                            onChange={(e) => setNumberOfLogs(e.target.value || '')}
                        />
                    </div>
                </div>
                <div className='action-buttons-container'>
                    <button
                        id='cancel-button'
                        onClick={() => onClick('Cancel')}
                        className='pospro-action-btn'>
                        Cancel
                    </button>
                    <button
                        id='apply-button'
                        onClick={() => onClick('Apply')}
                        className='pospro-action-btn bottom-anchor'>
                        Apply
                    </button>
                </div>
                <NumberOfLogsFormStyle />
            </div>
        </React.Fragment>
    )
}

export default React.memo(NumberOfLogsForm)